export default __webpack_public_path__ + "static/media/panteraico.02b9bb69.jpg";